import axiosInstance from "../API/interceptor";

export async function fetchListing(params) {
  const response = await axiosInstance.post("/task_assignment/get_listing", params);
  return response.data;
}